const categories = Object.freeze({
  Thrpy: 1,
  RP: 2,
});

export default categories;
